import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {FormField, FormFieldError} from "../../../../../../design-system/form-field";
import {ProfileFormValues} from "../../schema-validation";

const {TextArea} = Input;

export function ProfileShortBioFormField() {
  const {control} = useFormContext<ProfileFormValues>();

  return (
    <FormField
      id="shortBio"
      label="Short bio"
      renderInput={(id) => (
        <Controller
          control={control}
          name="shortBio"
          render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
            <Space size={8} direction="vertical" style={{display: "flex"}}>
              <TextArea
                id={id}
                status={error?.message ? "error" : ""}
                onChange={onChange}
                onBlur={onBlur}
                size="large"
                value={value === null ? undefined : value}
                placeholder="Tell your audience about yourself"
                ref={ref}
              />
              <FormFieldError errorMessage={error?.message} />
            </Space>
          )}
        />
      )}
    />
  );
}
